import { render } from "./Fields.vue?vue&type=template&id=6d441393"
import script from "./Fields.vue?vue&type=script&setup=true&lang=js"
export * from "./Fields.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d441393"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d441393', __exports__)) {
    api.reload('6d441393', __exports__)
  }
  
  module.hot.accept("./Fields.vue?vue&type=template&id=6d441393", () => {
    api.rerender('6d441393', render)
  })

}


export default __exports__